var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"domresize",rawName:"v-domresize",value:(_vm.resizeCharts),expression:"resizeCharts"}],staticClass:"word-chart",class:_vm.className,style:({ height:_vm.height,width:_vm.width}),attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }